import React from "react";

const Single = ({ image }) => {

	return (
		<div className="
			aspect-[1100/350]
			bg-cover
			bg-center
		"
		style={{
			backgroundImage: `url(//ps-images.imgix.net/${image.filename}?q=85&width=1440)`,
		}}
		></div>
	);
};

export default Single;
